import React from 'react';

import { LinkI18n } from '@/i18n/routing';

export function LinkConverters({
  children,
  from,
  to,
  ...props
}: Omit<React.HTMLAttributes<HTMLAnchorElement>, 'href'> & { from?: string; to?: string }) {
  const page = from?.length && to?.length ? `${from.toLowerCase()}-${to.toLowerCase()}` : '';

  return (
    <LinkI18n href={`/converters/${page}`} {...props} prefetch={false}>
      {children}
    </LinkI18n>
  );
}
